import { useState } from 'react';
import { useAuthFetch } from '../hooks/useAuthFetch';
import { useAuth } from '../contexts/AuthContext';

const is = {
  width: '100%', padding: '10px 12px', borderRadius: 8,
  background: '#0f1117', border: '1px solid #2a2d3e',
  color: '#e2e8f0', fontSize: 14, fontFamily: 'inherit',
  outline: 'none', boxSizing: 'border-box',
};

export default function ProfileModal({ onClose }) {
  const { user } = useAuth();
  const fetchWithAuth = useAuthFetch();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      setStatus('error'); setMessage('Les nouveaux mots de passe ne correspondent pas.'); return;
    }
    if (form.new_password.length < 8) {
      setStatus('error'); setMessage('Le nouveau mot de passe doit faire au moins 8 caractères.'); return;
    }
    setLoading(true);
    try {
      const res = await fetchWithAuth('/api/auth/change-password', {
        method: 'PUT',
        body: JSON.stringify({ current_password: form.current_password, new_password: form.new_password }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus('success');
        setMessage(data.message);
        setForm({ current_password: '', new_password: '', confirm: '' });
      } else {
        setStatus('error');
        setMessage(data.error || 'Une erreur est survenue');
      }
    } catch {
      setStatus('error'); setMessage('Erreur de connexion au serveur.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 400 }} />
      <div style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        width: 400, background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 14,
        padding: 28, zIndex: 401, boxSizing: 'border-box',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#e2e8f0' }}>Mon profil</h3>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{user?.prenom} {user?.nom} · {user?.role === 'admin' ? 'Administrateur' : 'Commercial'}</div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>

        <div style={{ borderTop: '1px solid #2a2d3e', paddingTop: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#94a3b8', marginBottom: 16 }}>Changer le mot de passe</div>

          {status === 'success' && (
            <div style={{ background: '#10b98120', border: '1px solid #10b98140', borderRadius: 8, padding: '10px 14px', color: '#10b981', fontSize: 13, marginBottom: 16 }}>
              {message}
            </div>
          )}
          {status === 'error' && (
            <div style={{ background: '#ef444420', border: '1px solid #ef444440', borderRadius: 8, padding: '10px 14px', color: '#ef4444', fontSize: 13, marginBottom: 16 }}>
              {message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {[
              ['current_password', 'Mot de passe actuel'],
              ['new_password', 'Nouveau mot de passe'],
              ['confirm', 'Confirmer le nouveau mot de passe'],
            ].map(([key, label]) => (
              <div key={key} style={{ marginBottom: 14 }}>
                <label style={{ display: 'block', fontSize: 12, color: '#64748b', marginBottom: 5, fontWeight: 500 }}>{label}</label>
                <input
                  type="password"
                  value={form[key]}
                  onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                  placeholder="••••••••"
                  style={is}
                  required
                />
              </div>
            ))}
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button
                type="submit"
                disabled={loading}
                style={{ flex: 1, padding: '11px', borderRadius: 8, background: loading ? '#35956aaa' : '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 14, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit' }}
              >
                {loading ? 'Enregistrement...' : 'Mettre à jour'}
              </button>
              <button type="button" onClick={onClose} style={{ padding: '11px 18px', borderRadius: 8, background: 'transparent', border: '1px solid #2a2d3e', color: '#64748b', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}>
                Annuler
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
